import {
  EKycVerificationStatus,
  ExamineeRegistrationStatus,
  ExamineeRegistrationType,
  RegistrationDocType,
} from '@exam-center/graphql';
import { ColorPalette } from '@shared/components';

export const REGISTRATION_STATUS_TEXT = {
  [ExamineeRegistrationStatus.NotRegistered]: 'ยังไม่ได้ลงทะเบียน',
  [ExamineeRegistrationStatus.Failed]: 'ลงทะเบียนไม่สำเร็จ',
  [ExamineeRegistrationStatus.Registered]: 'ลงทะเบียนเรียบร้อย',
};

export const REGISTRATION_STATUS_COLOR = {
  [ExamineeRegistrationStatus.NotRegistered]: ColorPalette.SECONDARY,
  [ExamineeRegistrationStatus.Failed]: ColorPalette.ERROR,
  [ExamineeRegistrationStatus.Registered]: ColorPalette.SUCCESS,
};

export const EKYC_STATUS_TEXT = {
  [EKycVerificationStatus.PendingApproval]: 'รอเจ้าหน้าที่ตรวจสอบ',
  [EKycVerificationStatus.Rejected]: 'ยืนยันตัวตนไม่สำเร็จ',
  [EKycVerificationStatus.Approved]: 'ยืนยันตัวตนเรียบร้อย',
  [EKycVerificationStatus.Expired]: 'หมดอายุแล้ว',
  [EKycVerificationStatus.NotStarted]: 'ยังไม่ได้ e-KYC',
  [EKycVerificationStatus.InProgress]: 'กำลัง e-KYC',
  [EKycVerificationStatus.Terminated]: 'TBD',
  [EKycVerificationStatus.NotRequired]: 'ไม่ต้องยืนยันตัวตน',
};

export const EKYC_STATUS_COLOR = {
  [EKycVerificationStatus.PendingApproval]: ColorPalette.INFO,
  [EKycVerificationStatus.Rejected]: ColorPalette.ERROR,
  [EKycVerificationStatus.Approved]: ColorPalette.SUCCESS,
  [EKycVerificationStatus.Expired]: ColorPalette.ERROR,
  [EKycVerificationStatus.NotStarted]: ColorPalette.SECONDARY,
  [EKycVerificationStatus.InProgress]: ColorPalette.WARNING,
  [EKycVerificationStatus.NotRequired]: ColorPalette.SECONDARY,
};

export const REGISTRATION_TYPE_TEXT = {
  [ExamineeRegistrationType.Attachments]: 'เอกสารอื่น',
  [ExamineeRegistrationType.DipChip]: 'Dip Chip',
};

export const DOCUMENT_TYPE = {
  [RegistrationDocType.CitizenCard]: 'บัตรประชาชน',
  [RegistrationDocType.DigitalDocument]: 'เอกสารราชการรูปแบบดิจิทัล',
  [RegistrationDocType.DipChip]: 'Dip Chip',
  [RegistrationDocType.DriverLicense]: 'ใบขับขี่',
  [RegistrationDocType.Passport]: 'พาสปอร์ต',
};
